import { FC } from 'react';
import { FamilyAnswersPage } from './family-answers.page';

export const FamilyAnswersAdminLevelPage: FC = () => <FamilyAnswersPage isAdminRoute={true} />;
